import { FC, lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { compose } from '@reduxjs/toolkit';
import { ILinkVisibilitySettings } from 'api/types';
import { sectionRoutes } from 'const';
import { GlobalFooterContainer } from 'portfolio3/containers/footers';
import { GlobalHeaderContainer, StudentHeaderContainer } from 'portfolio3/containers/headers';
import { IRootState } from 'reducers';

import {
  withBottomNavigation,
  withErrorBoundary,
  withFixedWidthContainer,
  withFooter,
  withHeader,
  withReferenceData,
  withRendererType,
  withStudentPaddingContainer,
  withThemeBackground,
} from '../hocs';

const ProfileSection = lazy(() => import('portfolio3/containers/sections/ProfileSection'));
const StudySection = lazy(() => import('portfolio3/containers/sections/StudySection'));
const ScienceSection = lazy(() => import('portfolio3/containers/sections/ScienceSection'));
const SportSection = lazy(() => import('portfolio3/containers/sections/SportSection'));
const CreationSection = lazy(() => import('portfolio3/containers/sections/CreationSection'));
const CultureSection = lazy(() => import('portfolio3/containers/sections/CultureSection'));
const CivilSection = lazy(() => import('portfolio3/containers/sections/CivilSection'));
const ProfessionSection = lazy(() => import('portfolio3/containers/sections/ProfessionSection'));
const RewardSection = lazy(() => import('portfolio3/containers/sections/RewardSection'));

interface ILinkRendererProps {
  linkVisibilitySettings: ILinkVisibilitySettings;
}

const LinkRenderer: FC<ILinkRendererProps> = ({ linkVisibilitySettings }) => {
  const match = useRouteMatch();
  const { display } = linkVisibilitySettings.content || {};

  return (
    <Suspense fallback={<></>}>
      <Switch>
        {display?.profile && <Route path={`${match.url}${sectionRoutes.PROFILE}`} render={() => <ProfileSection />} />}
        {display?.studies && <Route path={`${match.url}${sectionRoutes.STUDY}`} render={() => <StudySection />} />}
        {display?.science && <Route path={`${match.url}${sectionRoutes.SCIENCE}`} render={() => <ScienceSection />} />}
        {display?.sport && <Route path={`${match.url}${sectionRoutes.SPORT}`} render={() => <SportSection />} />}
        {display?.creation && (
          <Route path={`${match.url}${sectionRoutes.CREATION}`} render={() => <CreationSection />} />
        )}
        {display?.culture && <Route path={`${match.url}${sectionRoutes.CULTURE}`} render={() => <CultureSection />} />}
        {display?.civil && <Route path={`${match.url}${sectionRoutes.CIVIL}`} render={() => <CivilSection />} />}
        {display?.profession && (
          <Route path={`${match.url}${sectionRoutes.PROFESSION}`} render={() => <ProfessionSection />} />
        )}
        <Route path={`${match.url}${sectionRoutes.REWARD}`} render={() => <RewardSection />} />
      </Switch>
    </Suspense>
  );
};

const withRedux = connect((state: IRootState) => ({
  linkVisibilitySettings: state.linkVisibilitySettings,
}));

const isSideContainersFullWidth = false;

export default compose<FC>(
  withRedux,
  withRendererType('link'),
  withErrorBoundary(),
  withReferenceData(),
  withThemeBackground(),
  // уточнить про глобальный хедер в линк моде
  withHeader(GlobalHeaderContainer, isSideContainersFullWidth),
  withHeader(StudentHeaderContainer, isSideContainersFullWidth),
  withBottomNavigation(),
  withFooter(GlobalFooterContainer, isSideContainersFullWidth),
  withFixedWidthContainer(),
  withStudentPaddingContainer(),
)(LinkRenderer);
